import { render, staticRenderFns } from "./StatusCounts.vue?vue&type=template&id=6162fc41&scoped=true&"
import script from "./StatusCounts.vue?vue&type=script&lang=js&"
export * from "./StatusCounts.vue?vue&type=script&lang=js&"
import style0 from "./StatusCounts.vue?vue&type=style&index=0&id=6162fc41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6162fc41",
  null
  
)

export default component.exports